import { UserContext } from '@contexts/user/user.context'
import { IUser } from '@contexts/user/user.utils'
import { useSession } from 'next-auth/react'
import { useTranslation } from 'next-i18next'
import { FC, useContext } from 'react'

const CasesSection: FC<{ data: any; selectedSku: number }> = ({
  data,
  selectedSku,
}) => {
  const selectedOptionTierPrices: Record<
    string,
    {
      qty: string
      cust_group?: string
      all_groups?: string
      price: string
    }
  > | null = data?.option_prices?.[selectedSku?.toString()]?.tierPrices

  const { t: translate } = useTranslation('pdp')
  const { user } = useContext(UserContext) as IUser
  const { data: session } = useSession()

  const defaultTierPrices: Record<
    string,
    {
      price_qty: string
      cust_group?: string
      all_groups?: string
      website_price: string
    }
  > | null = data?.mag_attributes?.find(
    (attr: { attribute_code: string }) => attr.attribute_code === 'tier_prices',
  )?.value
  const effectiveTierPrices = selectedOptionTierPrices || defaultTierPrices
  const sellerPrice = data?.price
  const soldByOptions = ['each', 'box']
  const soldAs = data?.sold_as
  const showEs = soldByOptions.includes(soldAs)

  if (!effectiveTierPrices || Object.keys(effectiveTierPrices).length === 0)
    return null
  // Condition to check if there's a tier price entry for qty 1
  const userGroupId = user?.group_id?.toString()
  const oneQtytierPriceEntry =
    Object.values(effectiveTierPrices).find(
      (tier) =>
        parseFloat(tier.price_qty) === 1 &&
        tier.cust_group?.toString() === userGroupId,
    ) ||
    Object.values(effectiveTierPrices).find(
      (tier) => parseFloat(tier.price_qty) === 1 && tier.all_groups === '1',
    )

  // If a tier price entry for qty 1 exists, do not render anything
  if (oneQtytierPriceEntry) return null

  return (
    <ul className="c-product-shop-box__item-amount-price-table-items">
      {Object.entries(effectiveTierPrices).map(([key, tier]: [string, any]) => {
        let price = tier?.website_price || tier?.price
        let qty = tier?.price_qty || tier?.qty

        let percentageValue = tier?.percentage
          ? tier?.percentage
          : (((sellerPrice - price) * 100) / sellerPrice).toFixed(2)
        if (
          tier.cust_group === user?.group_id ||
          tier.all_groups === '1' ||
          (session?.isGuest && tier.cust_group === '0')
        ) {
          return (
            <li
              key={key}
              className="text-brand-dark font-medium flex justify-between items-center border p-3 mb-2"
            >
              <p>
                {translate('text-buynow')} {parseInt(qty, 10)}+{' '}
                <span className="capitalize text-brand-dark">
                  {soldAs}
                  {showEs ? 'es' : 's'}
                </span>
              </p>
              <span className="text-brand-dark">
                ${price}
                <span className="capitalize text-brand-dark">/{soldAs}</span>
              </span>
              {percentageValue && (
                <p className="text-brand-green">
                  {translate('text-save')} {percentageValue}%
                </p>
              )}
            </li>
          )
        }
      })}
    </ul>
  )
}

export default CasesSection
